import React from 'react';

export default function AnimatedBackground({ variant = 'default' }) {
  return (
    <div className="fixed inset-0 overflow-hidden pointer-events-none z-0">
      {/* Base gradient */}
      <div className="absolute inset-0 bg-gradient-to-b from-cao-darker via-cao-dark to-cao-darker" />

      {/* Animated gradient orbs */}
      <div className="absolute top-0 left-1/4 w-[800px] h-[800px] rounded-full bg-blue-600/10 blur-[120px] animate-pulse-slow" />
      <div className="absolute top-1/3 right-1/4 w-[600px] h-[600px] rounded-full bg-purple-600/10 blur-[100px] animate-pulse-slow" style={{ animationDelay: '2s' }} />
      <div className="absolute bottom-0 left-1/3 w-[700px] h-[700px] rounded-full bg-cyan-600/5 blur-[100px] animate-pulse-slow" style={{ animationDelay: '4s' }} />

      {/* Grid overlay */}
      <div
        className="absolute inset-0 opacity-30"
        style={{
          backgroundImage: `
            linear-gradient(rgba(59, 130, 246, 0.03) 1px, transparent 1px),
            linear-gradient(90deg, rgba(59, 130, 246, 0.03) 1px, transparent 1px)
          `,
          backgroundSize: '50px 50px',
        }}
      />

      {/* Scan lines */}
      {variant === 'cyber' && (
        <div className="absolute inset-0 overflow-hidden">
          <div
            className="absolute inset-x-0 h-[2px] bg-gradient-to-r from-transparent via-blue-500/20 to-transparent animate-scan-line"
            style={{ top: '-2px' }}
          />
        </div>
      )}

      {/* Floating shapes */}
      {variant === 'gaming' && (
        <>
          <div className="absolute top-20 left-10 w-4 h-4 border border-blue-500/30 rotate-45 animate-float float-1" />
          <div className="absolute top-40 right-20 w-6 h-6 border border-purple-500/30 rotate-12 animate-float float-2" />
          <div className="absolute bottom-40 left-1/4 w-3 h-3 bg-cyan-500/20 rounded-full animate-float float-3" />
          <div className="absolute top-1/3 left-20 w-8 h-8 border border-green-500/20 rounded-lg animate-float float-4" />
          <div className="absolute bottom-1/4 right-1/4 w-5 h-5 border border-blue-500/30 animate-float float-5" />

          {/* Hexagon patterns */}
          <svg className="absolute top-1/4 right-10 w-16 h-16 text-purple-500/10 animate-spin-slow" viewBox="0 0 100 100">
            <polygon points="50,5 95,27.5 95,72.5 50,95 5,72.5 5,27.5" fill="none" stroke="currentColor" strokeWidth="2" />
          </svg>
          <svg className="absolute bottom-1/3 left-16 w-12 h-12 text-blue-500/10 animate-spin-slow" style={{ animationDirection: 'reverse' }} viewBox="0 0 100 100">
            <polygon points="50,5 95,27.5 95,72.5 50,95 5,72.5 5,27.5" fill="none" stroke="currentColor" strokeWidth="2" />
          </svg>
        </>
      )}

      {/* Orbiting elements */}
      {(variant === 'orbit' || variant === 'gaming') && (
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
          <div className="relative w-[400px] h-[400px]">
            {/* Orbit rings */}
            <div className="absolute inset-0 border border-blue-500/10 rounded-full" />
            <div className="absolute inset-8 border border-purple-500/10 rounded-full" />
            <div className="absolute inset-16 border border-cyan-500/10 rounded-full" />

            {/* Orbiting dots */}
            <div className="absolute top-0 left-1/2 -translate-x-1/2 w-2 h-2 bg-blue-400 rounded-full animate-orbit" style={{ animationDuration: '20s' }} />
            <div className="absolute top-8 left-1/2 -translate-x-1/2 w-1.5 h-1.5 bg-purple-400 rounded-full animate-orbit" style={{ animationDuration: '15s', animationDirection: 'reverse' }} />
            <div className="absolute top-16 left-1/2 -translate-x-1/2 w-1 h-1 bg-cyan-400 rounded-full animate-orbit" style={{ animationDuration: '25s' }} />
          </div>
        </div>
      )}

      {/* Vignette */}
      <div
        className="absolute inset-0"
        style={{
          background: 'radial-gradient(ellipse at center, transparent 0%, rgba(5, 5, 8, 0.4) 70%, rgba(5, 5, 8, 0.8) 100%)',
        }}
      />
    </div>
  );
}
